import { StyledCollapsible } from './Collapsible.styles'
import { CollapsibleProps } from './Collapsible.types'

export const Collapsible = ({
    id,
    children,
    isExpanded,
    role,
    'aria-labelledby': ariaLabelledBy,
    'data-testid': testId,
}: CollapsibleProps) => (
    <StyledCollapsible
        id={id}
        role={role}
        isExpanded={isExpanded}
        data-testid={testId}
        aria-hidden={!isExpanded}
        aria-labelledby={ariaLabelledBy}
    >
        {children}
    </StyledCollapsible>
)
